export enum role_name {
    Admin = 'Administrador',
    AdminEmployer = 'Administrador Colegio',
    Employer = 'Colegio',
    Employee = 'Profesor',
    Accountant = 'accountant',
    Prospection = 'prospection',
}

export enum PROFILE {
    recruiter_basic = 'recruiter',
    recruiter_psychologist = 'psychologist',
    recruiter_complaint = 'complaint',
    recruiter_admin = 'admin',
}

export enum profile_access_module {
    employer_profile = 'employer_profile',
    salaries = 'salaries',
    employer_job = 'employer_job',
    search_talent = 'search_talent',
    employer_psycho_interview = 'employer_psycho_interview',
    employer_complaint_channel = 'employer_complaint_channel',
    employer_manager = 'employer_manager',
    employer_user = 'employer_user',
    employer_account = 'employer_account',
    employer_certificates = 'employer_certificates',
}

export const PROFILE_ACCESS = {
    [PROFILE.recruiter_basic]:
    {
        translatedName: 'Reclutador',
        roles: [
            profile_access_module.employer_profile,
            profile_access_module.salaries,
            profile_access_module.employer_job,
            profile_access_module.search_talent,
            profile_access_module.employer_account,
        ],
        validationPremium: []
    },
    [PROFILE.recruiter_psychologist]: {
        translatedName: 'Psicólogo',
        roles: [
            profile_access_module.employer_profile,
            profile_access_module.salaries,
            profile_access_module.employer_job,
            profile_access_module.search_talent,
            profile_access_module.employer_psycho_interview,
            profile_access_module.employer_account,
            profile_access_module.employer_certificates,
        ],
        validationPremium: ['interview']
    },
    [PROFILE.recruiter_complaint]: {
        translatedName: 'Denuncias',
        roles: [
            profile_access_module.employer_profile,
            profile_access_module.salaries,
            profile_access_module.employer_job,
            profile_access_module.search_talent,
            profile_access_module.employer_psycho_interview,
            profile_access_module.employer_complaint_channel,
            profile_access_module.employer_account,
            profile_access_module.employer_certificates,
        ],
        validationPremium: []
    },
    [PROFILE.recruiter_admin]: {
        translatedName: 'Administrador',
        roles: [
            profile_access_module.employer_profile,
            profile_access_module.salaries,
            profile_access_module.employer_job,
            profile_access_module.search_talent,
            profile_access_module.employer_psycho_interview,
            profile_access_module.employer_complaint_channel,
            profile_access_module.employer_manager,
            profile_access_module.employer_user,
            profile_access_module.employer_account,
            profile_access_module.employer_certificates,
        ],
        validationPremium: []
    }
};

export const PROFILE_TRANSLATED = Object.keys(PROFILE_ACCESS)
    .map(e => { return { id: e, text: PROFILE_ACCESS[e].translatedName } })
    .sort((a: any, b: any) => a.id.localeCompare(b.id))